// extracted by mini-css-extract-plugin
export default {"card":"Card_card__IiLiC","preview":"Card_preview__Htqvu","title":"Card_title__uVWUB","content":"Card_content__cPbLA"};